import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class PortalLink extends Component {

    shouldComponentUpdate(nextProps) {

        if(nextProps.cssClass != this.props.cssClass
            || nextProps.url != this.props.url
            || nextProps.text != this.props.text) {

            return true;
        }
        return false;
    }

    render() { 
        
        let itemClass = this.props.cssClass ? this.props.cssClass : '';

        return(               
            <Link data-cy={this.props.dataCy} to={this.props.url} className={itemClass}>
                {this.props.text}
            </Link>            
        );
    }
}

export default PortalLink;